import React from 'react';
import './styles.scss';
import img1 from 'assets/about-us/Mask London.png';

const AboutUsTravellingSection = () => {
  return (
    <div className="__AboutUsTravellingSection __my-container d-block d-lg-flex justify-content-between position-relative">
      <div className="__blog-section-wrapper">
        <h1 className="__main-title font_montserrat font-weight-bold font_corben">Welcome to Urbain</h1>
        <p className="font_montserrat __blog-section">
          Traveling is one of our favorite ways to escape our daily grind and relax, but the irony is that dealing with the logistics of travel are
          often incredibly stressful.
        </p>
        <p className="font_lato __blog-section">
          You plan an itinerary, book the tickets, navigate the airport, arrange local transportation, and when you finally arrive, you walk into…a
          boring, characterless, four-walled hotel box that could be anywhere. Or a dingy apartment with a leaky faucet and poor WiFi that looks
          nothing like the pictures you saw online. Or nothing but the sinking feeling that comes when you realize you’ve been scammed by your “host”.
          <br /> <br />
          It shouldn’t be so hard. You deserve a space where you can unpack and unwind, relax and recharge. We at Urbain have done the hard work of
          finding the best homes, connecting you to the one that perfectly fits your needs, and ensuring everything is seamless, simple and{' '}
          <span className="text-nowrap">safe—every</span> time.
          <br />
          <br />
          <h1 className="__subtitle font_corben font-weight-bold">
            Stay delighted. <span className="font_montserrat font-weight-normal">It sounds simple, but it means everything.</span>
          </h1>
        </p>
      </div>
      <img src={img1} alt="" className="__about-use-traviling-image d-none d-lg-block" />
    </div>
  );
};

export default AboutUsTravellingSection;
